module.exports = __webpack_public_path__ + "img/23_111.428433dd.png";